function Trashcan() {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trash-can-solid" clipPath="url(#clip0_16203_1389)">
        <path
          id="Vector"
          d="M3.66875 0.414844C3.79531 0.159375 4.05547 0 4.33906 0H7.16094C7.44453 0 7.70469 0.159375 7.83125 0.414844L8 0.75H10.25C10.6648 0.75 11 1.08516 11 1.5C11 1.91484 10.6648 2.25 10.25 2.25H1.25C0.835156 2.25 0.5 1.91484 0.5 1.5C0.5 1.08516 0.835156 0.75 1.25 0.75H3.5L3.66875 0.414844ZM1.25 3H10.25V10.5C10.25 11.3273 9.57734 12 8.75 12H2.75C1.92266 12 1.25 11.3273 1.25 10.5V3ZM3.5 4.5C3.29375 4.5 3.125 4.66875 3.125 4.875V10.125C3.125 10.3313 3.29375 10.5 3.5 10.5C3.70625 10.5 3.875 10.3313 3.875 10.125V4.875C3.875 4.66875 3.70625 4.5 3.5 4.5ZM5.75 4.5C5.54375 4.5 5.375 4.66875 5.375 4.875V10.125C5.375 10.3313 5.54375 10.5 5.75 10.5C5.95625 10.5 6.125 10.3313 6.125 10.125V4.875C6.125 4.66875 5.95625 4.5 5.75 4.5ZM8 4.5C7.79375 4.5 7.625 4.66875 7.625 4.875V10.125C7.625 10.3313 7.79375 10.5 8 10.5C8.20625 10.5 8.375 10.3313 8.375 10.125V4.875C8.375 4.66875 8.20625 4.5 8 4.5Z"
          fill="#FF2D55"
        />
      </g>
      <defs>
        <clipPath id="clip0_16203_1389">
          <rect width="10.5" height="12" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Trashcan
